/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Section } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { MultipleItemsCarousel, CarouselArrows } from './MultipleItemsCarousel';
import PropertyTypeSectionCard from './PropertyTypeSectionCard';

import './PropertyTypeSection.scss';

const NUMBER_OF_ITEM_PER_SWIPE_DESKTOP = 4;
const NUMBER_OF_ITEM_PER_SWIPE_MOBILE = 1;
const NUMBER_OF_ITEM_PER_SWIPE_TABLET = 2;
const PROPERTY_TYPES = ['apartments', 'sharedRoom', 'studio', 'privateRoom'];

const PropertyTypeSection = ({ deviceType }) => {
  const [page, setPage] = useState(0);

  const isDesktop = deviceType === 'desktop';
  const isTablet = deviceType === 'tablet';

  const getNumberOfItems = () => {
    if (isDesktop) {
      return NUMBER_OF_ITEM_PER_SWIPE_DESKTOP;
    } else if (isTablet) {
      return NUMBER_OF_ITEM_PER_SWIPE_TABLET;
    }
    return NUMBER_OF_ITEM_PER_SWIPE_MOBILE;
  };
  const maxPage = Math.round(PROPERTY_TYPES.length / getNumberOfItems());

  const renderCarouselItem = (type, key) => (
    <PropertyTypeSectionCard type={type} key={key} />
  );

  return (
    <Section background="light">
      <div className="property-type-section">
        <div className="property-type-section__header">
          <h2 className="property-type-section__header-title">
            {trans('landingpage.label.propertyTypes')}
          </h2>
          {!isDesktop && (
            <span className="property-type-section__arrows">
              <CarouselArrows page={page} setPage={setPage} maxPage={maxPage} />
            </span>
          )}
        </div>
        <div className="property-type-section__carousel">
          <MultipleItemsCarousel
            items={PROPERTY_TYPES.map(renderCarouselItem)}
            itemsPerSwipe={getNumberOfItems()}
            selectedPage={page}
          />
        </div>
      </div>
    </Section>
  );
};

PropertyTypeSection.propTypes = {
  deviceType: PropTypes.string.isRequired
};

PropertyTypeSection.defaultProps = {};

export default PropertyTypeSection;
